module.exports = __webpack_public_path__ + "img/plein.826d3e4.svg";